/**
 * Created by Abner Sui on 1/10/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Comment } from '../../../tamalelibs/models/workflow.model';
import { BriefConfig } from '../../../widgets/widgets.model';

@Component({
    selector: 'tam-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit, OnDestroy {

    @Input() comments: Array<Comment>;
    @Input() parentId: string;
    @Input() config: BriefConfig;

    constructor() { }

    ngOnInit() {
    }

    ngOnDestroy(): void {
    }

    getComments(): Array<Comment> {
        if (this.parentId) {
            return this.comments.filter(item => item.parentId === this.parentId).sort((c1, c2) => c1.submittedDate.getTime() - c2.submittedDate.getTime());
        } else {
            return this.comments.filter(item => !item.parentId).sort((c1, c2) => c1.submittedDate.getTime() - c2.submittedDate.getTime());
        }
    }

}
